var map = {
	"./79-plex-imc-type-1-diabetes-isletimmune-interface-banner.jpg": 1598,
	"./amyloid-formation-in-type-2-diabetes-t2d-banner.jpg": 1848,
	"./collection-card-all-banner.jpg": 6487,
	"./cystic-fibrosis-related-diabetes-cfrd-banner.jpg": 3729,
	"./exeter-archival-diabetes-biobank-eadb-banner.jpg": 3226,
	"./exocrine-pancreas-in-type-1-diabetes-banner.jpg": 6652,
	"./human-pancreas-analysis-program-hpap-banner.jpg": 8475,
	"./human-pancreas-development-banner.jpg": 3733,
	"./image-formats-suite-banner.jpg": 7025,
	"./images-with-metadata-banner.jpg": 8273,
	"./neonatal-development--early-life-pancreas-handel-p-banner.jpg": 9874,
	"./npod-case-6362-banner.jpg": 4348,
	"./pediatric-immune-tissue-development-handel-i-banner.jpg": 1564,
	"./single-cell-omics-datasets-banner.jpg": 1091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5037;